import { render, staticRenderFns } from "./CriteriaIndex.vue?vue&type=template&id=67f67714&"
import script from "./CriteriaIndex.vue?vue&type=script&lang=js&"
export * from "./CriteriaIndex.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaIndex.vue?vue&type=style&index=0&id=67f67714&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports